/**
 * Gallery Thumbnails — click to navigate, active state tracking
 * Extracted from sections/main-product.liquid
 */
(function() {
  'use strict';

  var galleryEl = document.querySelector('[id^="Gallery-"]');
  if (!galleryEl) return;

  var sectionId = galleryEl.id.replace('Gallery-', '');
  var gallery = galleryEl;
  var thumbsContainer = document.getElementById('GalleryThumbs-' + sectionId);
  if (!thumbsContainer) return;

  var thumbs = Array.from(thumbsContainer.querySelectorAll('.gallery-thumb'));
  var items = Array.from(gallery.querySelectorAll('.gallery-item'));
  if (!thumbs.length || !items.length) return;

  // Keep the active thumb visible WITHIN the thumbs container only.
  // Never use Element.scrollIntoView() here: when the thumbs are a wrapping
  // grid (no own scroll container) it would scroll the whole window/page to
  // the gallery instead. We only ever adjust the container's own scroll offset,
  // which is a no-op for the non-scrolling 2-column grid layout.
  function scrollThumbIntoView(thumb) {
    var cRect = thumbsContainer.getBoundingClientRect();
    var tRect = thumb.getBoundingClientRect();

    if (thumbsContainer.scrollWidth > thumbsContainer.clientWidth) {
      if (tRect.left < cRect.left) {
        thumbsContainer.scrollLeft += tRect.left - cRect.left;
      } else if (tRect.right > cRect.right) {
        thumbsContainer.scrollLeft += tRect.right - cRect.right;
      }
    }

    if (thumbsContainer.scrollHeight > thumbsContainer.clientHeight) {
      if (tRect.top < cRect.top) {
        thumbsContainer.scrollTop += tRect.top - cRect.top;
      } else if (tRect.bottom > cRect.bottom) {
        thumbsContainer.scrollTop += tRect.bottom - cRect.bottom;
      }
    }
  }

  thumbsContainer.addEventListener('click', function(e) {
    var thumb = e.target.closest('.gallery-thumb');
    if (!thumb) return;
    var index = parseInt(thumb.dataset.thumbIndex) || 0;
    gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'smooth' });
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = items.indexOf(entry.target);
        if (idx >= 0) {
          thumbs.forEach(function(t, i) {
            t.classList.toggle('gallery-thumb--active', i === idx);
          });
          if (thumbs[idx]) {
            scrollThumbIntoView(thumbs[idx]);
          }
        }
      }
    });
  }, { root: gallery, threshold: 0.6 });

  items.forEach(function(item) { observer.observe(item); });
})();
